import { Action } from "../actions/types"
import { TicketDetailsType, TicketDetailsActionList } from "../actions/ticketDetailsActions"

const initialValue: Array<TicketDetailsType> = []

const ticketDetailsReducer = (state: Array<TicketDetailsType> = initialValue, action: Action) => {
    switch (action.type) {

        case TicketDetailsActionList.ADD_TICKET_DETAILS:
            return [
                ...state,
                action.data,
            ]

        case TicketDetailsActionList.UPDATE_TICKET_DETAILS:
            const updated = [...state].slice()
            const index = updated.findIndex(u => u.id === action.data.id)

            if (index > -1) {
                updated[index] = {
                    ...action.data
                }
            }

            return updated

        case TicketDetailsActionList.FETCH_TICKET_DETAILS:
            return action.data

        default:
            return state
    }
}

export default ticketDetailsReducer